import classNames from "classnames";
import React from "react";
import { DoorIconProps } from "./DeKaap";

export const DeWaal: React.FC<DoorIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width={28}
      height={60}
      viewBox="0 0 28 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={classNames("gg-transition gg-duration-150 gg-ease-in-out", {
          "gg-fill-[#292747]": isActive,
          "gg-fill-[#9493A3]": !isActive,
        })}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.545 2h23.273v56H19V26c0-9.42-7.237-17.15-16.455-17.935zm0 7.07V58H18V26c0-8.868-6.79-16.15-15.455-16.93M.545 60V0h27.273v60z"
        fill="currentColor"
      />
    </svg>
  );
};
